import angular from 'angular';

class AppUtils {
  constructor($window) {
    'ngInject';

    this.$window = $window;
  }
  attachWindowEvents(events, fn) {
    const list = angular.isString(events) ? [events] : events;
    list.forEach((event) => this.$window.addEventListener(event, fn));
    return () => this.detachWindowEvents(list, fn);
  }
  detachWindowEvents(events, fn) {
    const list = angular.isString(events) ? [events] : events;
    list.forEach((event) => this.$window.removeEventListener(event, fn));
  }
  copyObjectValues(from, to, clean = true, only = [], ignored = []) {
    if (clean) {
      Object.keys(to).forEach((propName) => {
        delete to[propName];
      });
    }

    const copy = angular.copy(from);
    Object.keys(copy).forEach((propName) => {
      const shouldCopy = !only.length || only.includes(propName);
      const shouldIgnore = ignored.length && ignored.includes(propName);
      if (shouldCopy && !shouldIgnore) {
        to[propName] = copy[propName];
      }
    });
  }
  camelCaseToDash(str) {
    const firstLetter = str.substr(0, 1).toLowerCase();
    const rest = str.substr(1);
    const newStr = `${firstLetter}${rest}`;
    return newStr.replace(/([A-Z])/g, ($1) => {
      const letter = $1.toLowerCase();
      return `-${letter}`;
    });
  }
  capitalize(str) {
    const firstLetter = str.substr(0, 1).toUpperCase();
    const rest = str.substr(1);
    return `${firstLetter}${rest}`;
  }
  timestamp() {
    const millisecondsInASecond = 1000;
    return Math.floor(Date.now() / millisecondsInASecond);
  }
  toTimestamp(date) {
    const millisecondsInASecond = 1000;
    return date.getTime() / millisecondsInASecond;
  }
  sortObjectsList(property, order = 'asc') {
    const orderN = order === 'asc' ? 1 : -1;
    return (a, b) => {
      const propA = a[property];
      const propB = b[property];
      let result = 0;
      if (propA > propB) {
        result = 1 * orderN;
      } else if (propB > propA) {
        result = -1 * orderN;
      }

      return result;
    };
  }
  /**
   * Generates a random hash.
   * @return {string}
   */
  randomHash() {
    const radix = 36;
    const cutFrom = 2;
    const cutTo = 16;
    return Math.random().toString(radix).substr(cutFrom, cutTo);
  }
}

export default AppUtils;
